import externalLinksMixin from '@/mixins/externalLinks';

export default {
  mixins: [
    externalLinksMixin,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  created() {
    this.getExternalLogins({})
      .then((response) => {
        this.links = response.data;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/socials/socials.js